import styles from "./RenderingOverlay.module.css";
import { motion } from "framer-motion";

export const RenderingOverlay = () => {
  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className={styles.spinnerContainer}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.3 }}
      >
        <svg className={styles.spinner} viewBox="0 0 50 50">
          <motion.circle
            className={styles.spinnerPath}
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="3"
            initial={{ pathLength: 0, rotate: 0 }}
            animate={{
              pathLength: [0, 0.8, 0],
              rotate: 360,
            }}
            transition={{
              pathLength: {
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              },
              rotate: {
                duration: 2,
                repeat: Infinity,
                ease: "linear",
              },
            }}
          />
        </svg>
      </motion.div>
      <motion.span
        className={styles.text}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.3 }}
      >
        Preparing your print
      </motion.span>
    </motion.div>
  );
};
